<template>
  <div class="examIsValid">
    <div
      style="
        position: absolute;
        z-index: 10000;
        width: 100%;
        color: white;
        height: 96px;
        padding-top: 24px;
        background: linear-gradient(360deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
        opacity: 0.5;
      "
    >
      <div style="text-align: center">考试名称:{{ exam_name }}</div>
      <div style="margin-right: 15px; margin-top: 16px; float: right">
        <div
          style="
            background-color: red;
            color: white;
            border-radius: 14px;
            width: 60px;
            height: 24px;
            font-size: 12px;
            display: table-cell;
            text-align: center;
            vertical-align: middle;
          "
        >
          监控中
        </div>
      </div>
    </div>
    <div ref="video" class="realy-player-box"></div>
  </div>
</template>

<script>
/* eslint-disable */

// import { client as screenSender } from "../libs/screen";
import { client as cameraSender } from "../libs/camera";
import { Toast } from "vant";

async function processCamera(vm) {
  const client = cameraSender(
    vm.storage_para.data.userId,
    vm.storage_para.data.skuAppId,
    vm.storage_para.data.userSig,
    vm
  );
  // const client = cameraSender( '1' , '1400518039', 'eJyrVgrxCdZLrSjILEpVsjI0NTU1MjAw0AGLlqUWKVkpGekZKEH4xSnZiQUFmSlAdSYGBqaGFgbGlhCZzJTUvJLMtEywBkOY8sx0IC-XOC83pyIvPTjcrCCl0sI3JzUv1L0sPDXfOz0iMsTN1TjMu8KkzNuywDPbFqqxJDMX5BYzIyMDIxMjS7NaAHLhMG0_', vm);

  let chatsTimer;

  client.onLivingL = (localStream) => {
    const error_picture = setInterval(() => {
      const frame = localStream.getVideoFrame();

      if (frame && vm.error_flag) {
        let pa = { fra: frame };
        vm.sendPictures(pa);

        const img = document.getElementById("detImg");
        img.src = frame;
        vm.fnInit();
        vm.error_flag = false;
      }
    }, 10000);

    if (vm.begin_flag == false) {
      const begin_picture = setTimeout(() => {
        const frame = localStream.getVideoFrame();

        if (frame) {
          let pa = { fra: frame, type: 0 };
          vm.sendPicture(pa);

          const img = document.getElementById("detImg");
          img.src = frame;
          vm.fnInit();
          vm.begin_flag = true;
        }
      }, 700);
    }
    if (vm.end_flag == false) {
      const last_picture = setTimeout(() => {
        const frame = localStream.getVideoFrame();

        if (frame) {
          let pa = { fra: frame, type: 8 };
          vm.sendPicture(pa);
          vm.end_flag = true;
        }
      }, endtime);
    }
  };
  client.onLiveStarting = () => {
    vm.livingState = "living";

    vm && vm.$once("hook:beforeDestroy", () => {});
  };
  client.onLiveStoping = () => {
    vm.livingState = "finish";
    clearInterval(chatsTimer);
  };

  vm &&
    vm.$once("hook:beforeDestroy", async () => {
      clearInterval(chatsTimer);
      try {
        await client.leaveRoom();
      } catch (error) {}
    });
  return client;
}

// async function processScreen(vm) {
//   const client = screenSender(
//     vm.storage_para.data.userId,
//     vm.storage_para.data.skuAppId,
//     vm.storage_para.data.userSig
//   ); // sdkappid:1400518039  userId: 1
//   // const client = screenSender('1' , '1400518039', 'eJyrVgrxCdZLrSjILEpVsjI0NTU1MjAw0AGLlqUWKVkpGekZKEH4xSnZiQUFmSlAdSYGBqaGFgbGlhCZzJTUvJLMtEywBkOY8sx0IC-XOC83pyIvPTjcrCCl0sI3JzUv1L0sPDXfOz0iMsTN1TjMu8KkzNuywDPbFqqxJDMX5BYzIyMDIxMjS7NaAHLhMG0_'); // sdkappid:1400518039  userId: 1
//   client.onLiving = () => {
//     vm.shareScreening = true;
//   };
//   client.onLiveStoping = () => {
//     vm.shareScreening = false;
//   };
//
//   vm &&
//     vm.$once("hook:beforeDestroy", async () => {
//       try {
//         await client.stopSharing();
//       } catch (error) {}
//       try {
//         await client.leaveRoom();
//       } catch (error) {}
//     });
//
//   return client;
// }
export default {
  name: "examIsValid",

  data() {
    return {
      exam_name: null,
      showCheckDialog: false,
      distance: 0, // 对比误差值
      desc: [], // 样本矩阵
      orgImgEl: null,
      detImgEl: null,
      nets: "ssdMobilenetv1", // 模型
      params: {}, // 开直播参数
      succflag: true,
      userpaperid: null,
      storage_para: null,
      stream_stop: false,
      end: false,
      begin_flag: false,
      end_flag: false,
      error_flag: false,
      error_array: [],
    };
  },
  created() {
    this.params = Object.assign(this.params, this.$route.query);
    localStorage.setItem("LiveParam", JSON.stringify(this.params));
  },
  async mounted() {
    this.exam_name = sessionStorage.getItem("examname");

    let params = {
      channel: 2,
      businessId: sessionStorage.getItem("businessid"),
      examId: sessionStorage.getItem("examid"),
      businessType: sessionStorage.getItem("tasktype"),
      userPaperId: sessionStorage.getItem("userpaperid"),
    };

    this.storage_para = await this.$api.exam_live.queryLinkLiveData(params);
    let m = this.storage_para.data.userPaperId;
    if (
      sessionStorage.getItem("userpaperid") != "null" &&
      sessionStorage.getItem("userpaperid") != null &&
      sessionStorage.getItem("userpaperid") != ""
    ) {
      this.userpaperid = sessionStorage.getItem("userpaperid");
    } else this.userpaperid = m;
    sessionStorage.setItem("succuserpaperid", m);
    this._cameraClient = await processCamera(this);
    // this._screenClient = await processScreen(this);

    this._cameraClient.joinRoom(this.storage_para.data.roomId);
    // this._screenClient.joinRoom(this.storage_para.data.roomId); //200863
    this.timer = window.setInterval(() => {
      setTimeout(() => {
        this.reverseAsk();
      }, 0);
    }, 10000);
    this.$nextTick(() => {
      this.fnInit();
    });
    setTimeout(() => {
      this.clickSecondConfirmPop("start");
    }, 5000);
    setTimeout(() => {
      if (
        localStorage.getItem("uplinkNetworkQuality") == 1 ||
        localStorage.getItem("uplinkNetworkQuality") == 2 ||
        localStorage.getItem("uplinkNetworkQuality") == 3 ||
        localStorage.getItem("uplinkNetworkQuality") == 4
      )
        this.linkSucc();
    }, 3000);
    setInterval(() => {
      this.ExamTerminate();
    }, 10000);
    setInterval(() => {
      if (
        localStorage.getItem("uplinkNetworkQuality") == 1 ||
        localStorage.getItem("uplinkNetworkQuality") == 2 ||
        localStorage.getItem("uplinkNetworkQuality") == 3 ||
        localStorage.getItem("uplinkNetworkQuality") == 4
      )
        this.linkSucc();
    }, 20000);

    if (window.history && window.history.pushState) {
      // 往历史记录里面添加一条新的当前页面的url
      history.pushState(null, null, document.URL);
      // 给 popstate 绑定一个方法 监听页面刷新
      window.addEventListener("popstate", this.backChange, false); //false阻止默认事件
    }
  },
  methods: {
    async reverseAsk() {
      let para2 = {
        businessId: this.userpaperid,
        businessType: 2,
      };
      const res3 = await this.$api.exam_live.isPhotoRequired(para2);
      let container = JSON.parse(JSON.stringify(res3));
      if (container.message == "success") {
        if (container.data.need == true) {
          this.error_flag = true;
          this.error_array = container.data.records;
        }
      }
    },
    async sendPicture(pa) {
      let time =
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      let CaptureRecordDto = {
        businessId: this.userpaperid,
        businessType: 2,
        monitorTime: time,
        monitorType: pa.type,
        photoChannel: 2,
        userPhotoBase64: pa.fra,
      };
      const res = await this.$api.exam_live.sendPictureBase(CaptureRecordDto);
    },
    async sendPictures(pa) {
      this.error_array.forEach((element) => (element.userPhotoBase64 = pa.fra));
      this.error_array.forEach((element) => (element.photoChannel = 2));

      const res = await this.$api.exam_live.sendPicturesBase(this.error_array);
    },
    async ExamTerminate() {
      let params = { userPaperId: this.userpaperid };
      await this.$api.exam_live.isExamStop(params).then((res) => {
        if (res.message == "success") {
          console.log(res.data.end, "res", this.end, "this.end");
          if (res.data.end == true && this.end == false) {
            Toast({
              message: "考试已经结束",
              duration: 4000,
            });
            this.end = true;
            let tokens = localStorage.getItem("tokens");
            this.$router.push({
              path: "/device_check",
              query: {
                tokens,
              },
            });
          }
        }
      });
    },

    linkSucc() {
      let m = sessionStorage.getItem("succuserpaperid");
      let params = { channel: 2, userPaperId: m };
      let result = this.$api.exam_live.liveSuccess(params);
      if (this.succflag == true) {
        if (result.code == 0 && result.data == true) this.succflag = true;
        else {
          this.succflag = false;
          this.linkSucc();
        }
      }
      if (this.succflag == false) {
        if (result.code == 0 && result.data == true) this.succflag = true;
      }
    },
    // 初始化模型加载
    async fnInit() {
      // 节点属性化
      this.orgImgEl = document.getElementById("orgImg");
      this.detImgEl = document.getElementById("detImg");
    },
    clickSecondConfirmPop(flag) {
      if (flag == "start") {
        this.startLiving();
        setTimeout(() => {
          if (
            localStorage.getItem("uplinkNetworkQuality") == 1 ||
            localStorage.getItem("uplinkNetworkQuality") == 2 ||
            localStorage.getItem("uplinkNetworkQuality") == 3 ||
            localStorage.getItem("uplinkNetworkQuality") == 4
          )
            this.linkSucc();
        }, 1000);
      } else {
        this.stopLiving();
      }
    },
    startLiving() {
      this._cameraClient.startLiving(this.$refs.video);
    },
    async stopLiving() {
      this.livingTips_html = "";
      this.studentList = [];

      this._cameraClient.stopLiving();
      this.livingState = "finish";
    },
  },
  destroyed() {
    localStorage.removeItem("LiveParam");
    window.removeEventListener("popstate", this.backChange, false); //false阻止默认事件
  },
};
</script>
<style lang="stylus" scoped>
.realy-player-box {
  width: 750px;
  height: 1334px;
  background: #fff;
}
</style>
